/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/suspendUser.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SUSPEND_USER } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface suspendUserProps {
  ids: any;
}

export interface ISuspendUserMethods extends IPluginMethodMap {
  getSuspendUser(args: suspendUserProps): Promise<any>;
}

export class SuspendUserService implements IAgentPlugin {
  readonly methods: ISuspendUserMethods;

  constructor() {
    this.methods = {
      getSuspendUser: this.getSuspendUser.bind(this),
    };
  }

  async getSuspendUser(args: suspendUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SUSPEND_USER,
          variables: {
            email: args,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.suspendUser) {
          return {
            ...res?.data?.suspendUser,
            notification: notification?.suspendUserSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
